import { ROLE } from "../../../../utils/Constants";
import { getUser } from "../../../../utils/commonfunction";
import {
  CHATBOT_STORAGE_PREFIX,
  FALLBACK_STORAGE_USER_ID,
} from "./chatbotHook.constants";
import { createWelcomeMessage } from "./chatbotMessageUtils";
import type { RestaurantUser, WidgetState } from "./types";

export const getWidgetStorageKey = (): string => {
  const user = getUser(ROLE.RESTAURANT) as RestaurantUser | null;
  return `${CHATBOT_STORAGE_PREFIX}:${user?._id ?? FALLBACK_STORAGE_USER_ID}`;
};

export const getInitialState = (): WidgetState => {
  const fallback: WidgetState = {
    messages: [createWelcomeMessage()],
    sessionId: null,
  };

  try {
    const saved = sessionStorage.getItem(getWidgetStorageKey());
    return saved ? (JSON.parse(saved) as WidgetState) : fallback;
  } catch {
    return fallback;
  }
};

export const persistWidgetState = (
  storageKey: string,
  state: Pick<WidgetState, "messages" | "sessionId">
): void => {
  sessionStorage.setItem(storageKey, JSON.stringify(state));
};
